var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './TenantMenuView.html';
import './tenantMenu.scss';
import { TenantService, TenantRoles } from 'modules/application/tenant/TenantService';
import { SegmentService } from 'modules/application/misc/SegmentService';
import { AccountService2 } from 'modules/account/AccountService2';
import { ContextProcessorService, Contexts } from 'modules/core/ContextProcessorService';
import { IStateService } from 'angular-ui-router';
import { BlipService } from 'modules/messaginghub/BlipService';
import { ORGANIZATION_CONTRACT_PANEL, ORGANIZATION_MENU_DROPDOWN, ORGANIZATION_MENU_SHOW_MORE, } from 'modules/application/tenant/TenantSegmentEvents';
import { NavbarFeatures } from '../NavbarFeatures';
export const TENANT_PANEL_LINK = '/application/tenant/';
let TenantMenuComponent = class TenantMenuComponent {
    static $inject = ['SegmentService', 'TenantService', 'AccountService2', 'ContextProcessorService', '$state', 'BlipService', 'USER_AVATAR_DEFAULT_IMAGE', '$translate'];
    constructor(SegmentService, TenantService, AccountService2, ContextProcessorService, $state, BlipService, USER_AVATAR_DEFAULT_IMAGE, $translate) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.TenantService = TenantService;
        this.AccountService2 = AccountService2;
        this.ContextProcessorService = ContextProcessorService;
        this.$state = $state;
        this.BlipService = BlipService;
        this.USER_AVATAR_DEFAULT_IMAGE = USER_AVATAR_DEFAULT_IMAGE;
        this.$translate = $translate;
        this.isTenantMenuExpanded = false;
        this.panelLink = TENANT_PANEL_LINK;
    }
    async $onInit() {
        await this.ContextProcessorService.waitForInitialization();
        await this.checkFeatures();
        this.personalTenant = await this.TenantService.getPersonalTenant();
        this.currentTenant = this.ContextProcessorService.context === Contexts.Default ?
            this.personalTenant : this.ContextProcessorService.tenant;
        if (this.isCreateButtonsDisabledOnSharedView) {
            this.personalTenant.name = this.$translate.instant('navbar.subheader.sharedWithMe');
        }
        this.tenants = await this.getUserTenants();
        this.currentTenantAccountType = await this.getTenantCluster();
    }
    async checkFeatures() {
        this.isCreateButtonsDisabledOnSharedView = await NavbarFeatures.isCreateButtonsOnSharedViewDisabled();
    }
    onOpenTenantPanel() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_CONTRACT_PANEL, {
            status: 'success',
            tab: 'overview',
        });
        window.location.href = this.panelLink;
        return;
    }
    async getTenantCluster() {
        return this.TenantService.getTenantPlan(this.currentTenant.id);
    }
    async handleOnMenuOpen() {
        this.isTenantMenuExpanded = this.tenants && this.tenants.length <= 3;
        const currentUser = await this.AccountService2.me();
        this.canAccessDashboard = await this.TenantService.hasRequiredTenantRole(currentUser.identity, this.currentTenant.id, [TenantRoles.Admin]);
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MENU_DROPDOWN);
    }
    showMoreTenants(event) {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MENU_SHOW_MORE);
        event.stopPropagation();
        this.isTenantMenuExpanded = true;
    }
    tenantUrl() {
        return this.currentTenant ? this.TenantService.getTenantUrl(this.currentTenant.id, false) : '';
    }
    async getUserTenants() {
        try {
            await this.BlipService.waitForInitialization();
            const { items: tenants } = await this.TenantService.mine();
            const orderedTenants = this.orderTenants([this.personalTenant, ...tenants.reverse()]);
            return orderedTenants.filter(t => t.id !== this.currentTenant.id);
        }
        catch (e) {
            console.error(e);
            return undefined;
        }
    }
    orderTenants(tenants) {
        const lastUsedTenantsExtra = this.user.extras && this.user.extras.lastUsedTenants || '[]';
        const lastUsedTenants = JSON.parse(lastUsedTenantsExtra);
        return tenants.sort((a, b) => lastUsedTenants.indexOf(b.id) - lastUsedTenants.indexOf(a.id));
    }
    setOpenMenu() {
        const e = document.getElementById('menuContract');
        e.open = !e.open;
        this.handleOnMenuOpen();
    }
};
TenantMenuComponent.$inject = ['SegmentService', 'TenantService', 'AccountService2', 'ContextProcessorService', '$state', 'BlipService', 'USER_AVATAR_DEFAULT_IMAGE', '$translate'];
TenantMenuComponent = __decorate([
    Component({
        template,
        transclude: true,
        bindings: {
            onMenuOpen: '&',
            user: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof SegmentService !== "undefined" && SegmentService) === "function" ? _a : Object, typeof (_b = typeof TenantService !== "undefined" && TenantService) === "function" ? _b : Object, typeof (_c = typeof AccountService2 !== "undefined" && AccountService2) === "function" ? _c : Object, typeof (_d = typeof ContextProcessorService !== "undefined" && ContextProcessorService) === "function" ? _d : Object, typeof (_e = typeof IStateService !== "undefined" && IStateService) === "function" ? _e : Object, typeof (_f = typeof BlipService !== "undefined" && BlipService) === "function" ? _f : Object, String, Object])
], TenantMenuComponent);
export { TenantMenuComponent };
